module.exports = __webpack_public_path__ + "img/update-details-fill.ae9518e3.svg";